package com.example.socialmediaapp

interface Platform {
    val name: String
    val isAdminDomain: Boolean
}

expect fun getPlatform(): Platform

// ============================================
// TOKEN STORAGE (expect/actual)
// ============================================

// Launch a Jitsi Meet call — platform-specific implementation
expect fun openVideoCall(roomUrl: String, isVideo: Boolean)

// Platform-safe current time in milliseconds
expect fun currentTimeMillis(): Long

// Local date/time components from epoch milliseconds (respects device timezone)
data class LocalDateComponents(
    val year: Int, val month: Int, val day: Int,
    val hour: Int, val minute: Int,
    val dayOfWeekSun0: Int  // 0=Sunday, 1=Monday, ..., 6=Saturday
)
expect fun getLocalDateComponents(timestamp: Long): LocalDateComponents

expect class TokenStorage() {
    fun saveToken(token: String)
    fun getToken(): String?
    fun clearToken()
    fun saveUserId(userId: String)
    fun getUserId(): String?
    fun saveUsername(username: String)
    fun getUsername(): String?
    fun getDeviceId(): String?
    fun getHandshake(): String?
}
